import { View } from '../../base/View';
import { ensureElement } from '../../../utils/utils';
import { SETTINGS, AppStateComponents } from '../../../utils/constants';
// Главная страница
export class PageView extends View {
    // Конструктор принимает родительский элемент и обработчик событий
    constructor(container, events) {
        super(container);
        this.events = events;
        this._counter = ensureElement(SETTINGS.pageSettings.counter);
        this._products = ensureElement(SETTINGS.pageSettings.gallery);
        this._wrapper = ensureElement(SETTINGS.pageSettings.wrapper);
        this._basket = ensureElement(SETTINGS.pageSettings.basket);
        this._basket.addEventListener('click', () => this.events.emit(AppStateComponents.BASKET.OPEN));
    }
    // Сеттер для счётчика товаров в корзине
    set counter(value) {
        this.setText(this._counter, String(value));
    }
    // Сеттер для карточек товаров на странице
    set products(items) {
        this._products.replaceChildren(...items);
    }
    // Сеттер для блока прокрутки
    set locked(state) {
        if (state)
            this._wrapper.classList.add(SETTINGS.pageSettings.locked);
        else
            this._wrapper.classList.remove(SETTINGS.pageSettings.locked);
    }
}
